const Privacy = () => {
    return (<div>Privacy Policy coming soon...</div>)
}

export default Privacy;